export const destinos = {
  'ME': 'MEX',
  'PB': 'PUE',
  'NL': 'MTY',
  'CO': 'SAL',
  'CX': 'MEX'
}